/* eslint no-console: "off", quotes: "off" */
import { mapState, mapActions, mapMutations } from "vuex";
import ResumeGame from "@/components/home/modals/ResumeGame";
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import Maintenance from '@/components/home/modals/Maintenance';

const NewGameMixin = {
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'checkCoreResponses',
    ]),
    playGame(gameType) {
      this.checkCoreResponses().then((response) => {
        console.log(gameType);
        if (response === 'CORE_IS_DOWN') {
          this.storeModalForHomePage(Maintenance);
          this.showModalForMaintenance();
        } else {
          this.checkIfGameToResumeExists().then(() => {
            console.log('this.gameInProgress in Home js:', this.gameInProgress);
            if (this.gameInProgress) {
              console.log('showing resume game pop up in Home js...');
              this.storeModalForHomePage(ResumeGame);
              this.showHideModal();
            } else if ((!this.isEligibleToPlay(gameType)) && !this.userDetails.subscribed) {
              if (this.subAndUnsubViaSMS) {
                if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                  this.storeModalForHomePage(ResubscribeGameSms);
                } else {
                  this.storeModalForHomePage(ResubscribeGame);
                }
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
              this.showHideModal();
            } else if ((!this.isEligibleToPlay(gameType)) && this.userDetails.subscribed) {
              this.storeModalForHomePage(ZeroBalance);
              this.showHideModal();
            } else if (!['MW', 'ODD', 'SD'].includes(gameType)) {
              this.storeModalForHomePage(Maintenance);
              this.showHideModal();
            } else {
              this.$router.push(`/searchingOpponent/${gameType}`);
            }
          }).catch(error => console.error(error));
        }
      }).catch(error => console.error(error));
    },
    isEligibleToPlay(gameType) {
      if (this.userDetails.availableCoins !== 0) {
        if (gameType === 'MW' && this.userDetails.availableCoins < this.mwCoinsCost) return false;
        if (gameType === 'ODD' && this.userDetails.availableCoins < this.oddCoinsCost) return false;
        if (gameType === 'SD' && this.userDetails.availableCoins < this.sdCoinsCost) return false;
        return true;
      } return false;
    },
    showModalForMaintenance() {
      /* eslint-disable */
      // open modal
      this.$nextTick(() => {
        console.log('Open Maintenance modal...');
        $('.modal,.modal-overlay').fadeIn(200);
        // hide modal
        $('.modal-close, .modal-overlay').click(() => {
          console.log('Hide Maintenance modal and log out...');
          this.storeModalForHomePage(null);
          window.location.reload();
          this.$router.push('/');
        });
      });
      /* eslint-enable */
    },
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // hide modal
        $('.modal-close, .modal-overlay').click(() => {
          /* eslint-enable */
          this.storeModalForHomePage(null);
        });
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('profile', [
      'sdCoinsCost',
      'mwCoinsCost',
      'oddCoinsCost',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
  },
};

export default NewGameMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/home.js